<template>
  <v-container fluid>
    <v-dialog
        v-model="editDialog"
        max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ isEditing ? 'Редактирование данных' : 'Добавление'}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.jobName"
                    label="Наименование"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.price"
                    label="Цена"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.duration"
                    type="number"
                    label="Продолжительность"
                ></v-text-field>
              </v-col>
              <v-col cols="12"
                     sm="6"
                     md="4">
                <v-select v-model="editedItem.categoryId" :items="categories" item-text="name" item-value="id" label="Категория" dense />
              </v-col>
              <v-col cols="12"
                     sm="6"
                     md="4">
                <v-select v-model="editedItem.serviceJobs" :items="jobs" label="Работы ТО" multiple dense />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="close"
          >
            Отмена
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="save"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Панель фильтров -->
    <v-card class="mb-4">
      <v-card-title>
          Виды работ
      </v-card-title>
    </v-card>
    <v-card class="mt-6">
      <v-data-table
          :headers="headers"
          :items="data"
          class="elevation-1"
          :footer-props="{
            'items-per-page-text': 'Строк на странице:',
            'items-per-page-options': [5, 10, 20, 50]
          }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row>
              <v-col>
                <v-btn
                    @click="addJob"
                    depressed
                    color="primary"
                >
                  <v-icon
                      left
                      dark
                  >
                    mdi-plus
                  </v-icon>
                  Добавить
                </v-btn>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
              class="mr-2"
              @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
              class="mr-2"
              @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import {showSnackbar} from "@/plugins/eventBus";

export default {
  name: 'PartnerJobs',
  data() {
    return {
      editedItem: {
        jobName: null,
        price: null,
        duration: null,
        categoryId: null,
        serviceJobs: null,
      },
      editDialog: false,
      data: [],
      size: 10,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Наименование', value: 'jobName' },
        { text: 'Цена', value: 'price' },
        { text: 'Длительность', value: 'durationText' },
        { text: 'Категория', value: 'categoryName' },
        { text: 'Действия', value: 'actions' },
      ],
      totalElements: 0,
      options: {},
      jobs: [],
      categories: [],
      isEditing: false,
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true,
    },
  },
  mounted() {
    this.getData()
    this.getJobsHistory()
    this.getPartnerCategories()
  },
  methods: {
    addJob() {
      this.editDialog = true
    },
    async getJobsHistory () {
      try {
        this.jobs = await this.$store.dispatch('partnerJobs/getJobsHistory')
      } catch (e) {
        console.log(e)
      }
    },
    async getPartnerCategories () {
      try {
        this.categories = await this.$store.dispatch('partnerJobs/getPartnerCategories')
      } catch (e) {
        console.log(e)
      }
    },
    close () {
      this.isEditing = false
      this.editDialog = false
      this.editedItem = {
        jobName: null,
        price: null,
        duration: null,
        category: null,
      }
    },
    async save () {
      console.log(this.editedItem)
      if (this.isEditing) {
        console.log('isEditing')
      } else {
        try {
          this.editedItem.categoryId = this.editedItem.categoryId.toString()
          await this.$store.dispatch('partnerJobs/createJob', this.editedItem)
          showSnackbar({
            message: "Успешно добавлено!",
            color: "success",
            timeout: 3000,
          })
        } catch (e) {
          showSnackbar({
            message: "Не удалось добавить",
            color: "error",
            timeout: 3000,
          })
        }
      }

      this.isEditing = false
      this.editDialog = false
      this.editedItem = {
        jobName: null,
        price: null,
        duration: null,
        category: null,
      }
    },
    async deleteItem (item) {
      try {
        if (confirm('Вы точно хотите удалить данные?')) {
          await this.$store.dispatch('partnerJobs/deleteJob', item.id)
          this.getData()
          showSnackbar({
            message: "Успешно удалено!",
            color: "success",
            timeout: 3000,
          })
        }
      } catch (e) {
        showSnackbar({
          message: "Не удалось удалить",
          color: "error",
          timeout: 3000,
        })
      }
    },
    editItem (item) {
      this.isEditing = true
      this.editedItem = Object.assign({}, item)
      this.editDialog = true
    },
    async getData () {
      try {
        const data = await this.$store.dispatch('partnerJobs/getPartnerJobs')
        this.data = data.map((item) => {
          item.categoryName = item.category.name
          if (item.duration > 60) {
            item.durationText = Math.trunc(item.duration / 60) + ' ч. ' + (item.duration % 60 ? (item.duration % 60 + ' минут') : '')
          }
          return item
        })
      } catch (e) {
        console.log(e)
      }
    },
  }
}
</script>
<style scoped>

</style>